import React from 'react';

const SettingsDialog = ({ isOpen, onClose, apiKey, onApiKeyChange }) => {
  if (!isOpen) return null;

  return (
    <div className="modal-overlay">
      <div className="settings-content">
        <h2>设置</h2>
        <div className="settings-form">
          <label>
            API Key:
            <input
              type="password"
              value={apiKey}
              onChange={(e) => onApiKeyChange(e.target.value)}
              placeholder="请输入您的 API Key"
            />
          </label>
        </div>
        <div className="settings-actions">
          <button onClick={onClose}>关闭</button>
        </div>
      </div>
    </div>
  );
};

export default SettingsDialog; 